import { faFingerprint } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { startAuthentication, startRegistration, WebAuthnAbortService } from "@simplewebauthn/browser"
import { useEffect, useRef, useState } from "react"
import { Alert, Button, Spinner, Stack } from "react-bootstrap"

// TODO anys
interface PasskeyProps {
  webAuthnParams: any
  onSuccess: (authenticationResponse: any) => Promise<void>
  onCancel: () => void
  onAlternativeSelection?: () => void
}

export const Passkey = ({ webAuthnParams, onSuccess, onCancel, onAlternativeSelection }: PasskeyProps) => {
  const triggered = useRef(false)
  const [failed, setFailed] = useState(false)
  const [retryTrigger, setRetryTrigger] = useState(0)

  const creation = webAuthnParams && typeof webAuthnParams === 'object' && 'rp' in webAuthnParams && 'user' in webAuthnParams

  useEffect(() => {
    const triggerWebAuthn = async () => {
      try {
        triggered.current = true
        setFailed(false)
        if (creation) {
          const response = await startRegistration({ optionsJSON: webAuthnParams })
          await onSuccess(response)
        } else {
          const response = await startAuthentication({ optionsJSON: webAuthnParams })
          await onSuccess(response)
        }
      } catch (error) {
        console.log(error)
        setFailed(true)
      } finally {
        triggered.current = false
      }
    }

    if (!triggered.current) {
      triggerWebAuthn()
    }

    return () => {
      WebAuthnAbortService.cancelCeremony()
    }

  }, [webAuthnParams, retryTrigger])

  return <div>
    <Stack gap={1}>
      {
        failed ? <>
          <Alert variant="warning">{creation ? "Passkey creation cancelled" : "Passkey authentication cancelled"}</Alert>
          <Button variant="primary" onClick={() => setRetryTrigger(retryTrigger + 1)}>Try again</Button>
        </> :
          <Alert variant="dark"><FontAwesomeIcon icon={faFingerprint} /> {creation ? "Creating passkey..." : "Authenticating..."}</Alert>
      }
      <Button variant="secondary" onClick={onCancel}>Cancel</Button>
      {onAlternativeSelection && <Button variant="link" className="text-decoration-none" onClick={onAlternativeSelection}>Use one-time password</Button>}
    </Stack>
  </div>
}
